import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'components',
    pluginName: 'PRODUCT',
    entityName: 'BATTERY',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
});
// Fetch battery action creators

export const fetchBatteryInit = () => {
    return crudActions.fetchInit();
};
export const fetchBatteryStart = () => {
    return crudActions.fetchStart();
};
export const fetchBatterySuccess = (fetchBatteryCount, listBatteryCount) => {
    return crudActions.fetchSuccess(fetchBatteryCount, listBatteryCount);
};
export const fetchBatteryFail = () => {
    return crudActions.fetchFail();
};

export const fetchBatteryCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchBatteryStart());
        try {
            let countRes = await rest.post("components/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchBatterySuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchBatteryFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch battery."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchBatteryFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch battery."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchBattery = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchBatteryStart());
        try {
            let listRes = await rest.post("components/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchBatterySuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchBatteryFail());
            return []

        } catch (error) {
            dispatch(fetchBatteryFail());
            return []
        }
    }
}

// Load battery action creators
export const loadBatteryInit = () => {
    return crudActions.loadInit();
};
export const loadBatteryStart = () => {
    return crudActions.loadStart();
};
export const loadBatterySuccess = loadedBattery => {
    return crudActions.loadSuccess(loadedBattery);
};
export const loadBatteryFail = error => {
    return crudActions.loadFail(error);
};
export const loadBattery = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

// Create Battery  action creators
export const createBatteryInit = () => {
    return crudActions.createInit();
};
export const createBatteryStart = () => {
    return crudActions.createStart();
};
export const createBatterySuccess = createdBattery => {
    return crudActions.createSuccess(createdBattery);
};
export const createBatteryFail = error => {
    return crudActions.createFail(error);
};

export const createBattery = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createBatteryStart());
        try {
            let res = await rest.post('/components/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createBatterySuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created battery.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createBatteryFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create battery."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create battery."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createBatteryFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Edit Battery  action creators
export const editBatteryInit = () => {
    return crudActions.editInit();
};
export const editBatteryStart = () => {
    return crudActions.editStart();
};
export const editBatterySuccess = editedBattery => {
    return crudActions.editSuccess(editedBattery);
};
export const editBatteryFail = error => {
    return crudActions.editFail(error);
};
export const editBattery = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editBatteryStart());
        try {
            let res = await rest.post('/components/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editBatterySuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated battery.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editBatteryFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit battery."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit battery."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editBatteryFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete battery action creators
export const bulkDeleteBatteriesInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteBatteriesStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteBatteriesSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteBatteriesFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteBatteries = batteryIds => {
    return async dispatch => {
        await crudActions.bulkDelete(dispatch, batteryIds);
    };
};

// Delete battery  action creators
export const deleteBatteryInit = () => {
    return crudActions.deleteInit();
};
export const deleteBatteryStart = () => {
    return crudActions.deleteStart();
};
export const deleteBatterySuccess = deletedBattery => {
    return crudActions.deleteSuccess(deletedBattery);
};
export const deleteBatteryFail = error => {
    return crudActions.deleteFail(error);
};
export const deleteBattery = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};
export const setBattery = (data) => {
    return ({
        type: 'HANDLE_BATTERY',
        battery: { ...data, fromProduct: true }
    });
}
export const cleanState = (data) => {
    return ({
        type: 'CLEAN_STATE',
        battery: data
    });
}
